import { Map } from 'mapbox-gl';

export const RemoveLayer = (map: Map, id: string): void => {
  if (map.getLayer(id)) {
    map.removeLayer(id);
    map.removeSource(id);
  }
};

export const RemoveOnlyLayer = (map: Map, id: string): void => {
  if (map.getLayer(id)) {
    map.removeLayer(id);
  }
};
